import { EntityNode } from "./EntityNode";
import { GameObjectManager } from "../GameObjectManager";
import { RotationNode } from "../Nodes/RotationNode";
import { EntityManager } from "../EntityManager";
import { PlanManager } from "../../../../cocosPlan";
import { ArrangementGroup, Events, eventsManager, GeometryGroup, math } from "@rhinov/savane-js";

declare var cc: any;

export class GroupNode extends EntityNode {
    constructor(group: GeometryGroup | ArrangementGroup) {
        super(group);

        this.LINE_WIDTH = 2.0;

        this._sprite = null;
        this.group = this.savaneEntity;
        this.myAngle = 0;
        //this.setName('Arrangement' + arrangement.id);
        var cocosLength = this.group.realWidth / 10;
        var cocosWidth = this.group.realLength / 10;

        // Clamp the display to be minimum 1px width and height
        if (cocosLength < 1) {
            cocosLength = 1;
        }
        if (cocosWidth < 1) {
            cocosWidth = 1;
        }

        this.layerColor = new cc.color(100, 150, 200, 150);
        this.setPosition(GameObjectManager.convertToCocosCoord(this.group.transform.localPosition));

        //Bounding box layer
        this.layer = new cc.DrawNode();
        this.layer.setName('GroupLayer');
        this.layer.setAnchorPoint(new cc.p(0.5, 0.5));
        this.addChild(this.layer, 8);
        this.layer.setPosition(cc.p(0, 0));
        this.layer.drawRect(cc.p(-cocosWidth / 2, -cocosLength / 2), cc.p(cocosWidth / 2, cocosLength / 2), null, this.LINE_WIDTH, this.layerColor);
        this.layer.setVisible(true);

        //---ROTATION BUTTON
        this.rotateSprite = new RotationNode(this.group);
        this.addChild(this.rotateSprite, 8);

        //Menu var
        this.menuVisible = false;
        // In order to redraw the object only when needed
        this.needRedraw = true;

        // Set arrangement visibility depending on hide/display arrangement parameter
        if (this.group.isArrangementGroupEntity()) {
            this.setVisible(!PlanManager.getInstance()._hideArrangements);
        }

        this.update(undefined);

        this.hideArrangement = eventsManager.instance.addListener(Events.HIDE_ARRANGEMENTS, (_event: any) => {
            if (this.group.isArrangementGroupEntity())
                return;

            this.needRedraw = true;
            this.setVisible(!PlanManager.getInstance()._hideArrangements);
        });
    }

    // Return the sprite width
    getWidth(): number {
        return this._sprite.width;
    }

    // Return the sprite height
    getHeight(): number {
        return this._sprite.height;
    }

    update(dt: any) {
        if (this.needRedraw || this._isSelected || this._isHovered) {
            super.update(dt);

            // If need to redraw an group then redraw all children
            if (this.group.isArrangementGroupEntity() || this.group.isGeometryGroupEntity()) {
                for (var i = 0; i < this.group.children.length; i++) {
                    var node = EntityManager.getInstance().getNode(this.group.children[i]);

                    if (node !== null) {
                        node.needRedraw = true
                    }
                }
            }

            if (this.savaneEntity.isGhost()) {
                this.needRedraw = false;
                return;
            }

            this.recomputeMenu();

            if (this._isSelected) {
                if (!this.rotateSprite.isVisible()) {
                    this.addMenu();
                }
            } else {
                if (this.rotateSprite.isVisible()) {
                    this.deleteMenu();
                }
            }

            this.needRedraw = false;
        }
    }

    getRotationZ(): number {
        return this.myAngle;
    }

    setHovered(val: boolean) {
        super.setHovered(val);
    }

    /**
    * Select node and children
    **/
    setSelected(value: boolean) {
        if (this._isSelected !== value) {
            this.needRedraw = true;
        }

        super.setSelected(value);
    }

    addLayer() {
        this.layer.setVisible(true);
    }

    deleteLayer() {
        this.layer.setVisible(false);
    }

    addMenu() {
        this.menuVisible = true;
        this.rotateSprite.setVisible(true);
    }

    deleteMenu() {
        this.menuVisible = false;
        this.rotateSprite.setVisible(false);
    }

    recomputeMenu() {
        this.rotateSprite.update();
        var cocosLength = this.group.width / 10;
        var cocosWidth = this.group.length / 10;
        // Clamp the display to be minimum 1px width and height
        if (cocosLength < 1) {
            cocosLength = 1;
        }
        if (cocosWidth < 1) {
            cocosWidth = 1;
        }
        this.layer.clear();

        this.layer.drawRect(cc.p(-cocosWidth / 2, -cocosLength / 2), cc.p(cocosWidth / 2, cocosLength / 2), null, this.LINE_WIDTH, this.layerColor);
    }

    toRotate(position: math.vec3) {
        return this.rotateSprite.toRotate(position);
    }

    onEnter() {
        super.onEnter();
        //Listener for hover enter
        this.hoverListener = eventsManager.instance.addListener(Events.ENTITY_HOVER, (datas: any) => {
            if (this.group._id === datas.getUserData().id) {
                //Change hovered state
                this.setHovered(datas.getUserData().value);
            }
        });
    }

    onExit() {
        super.onExit();
        eventsManager.instance.removeListener(this.hoverListener);
        eventsManager.instance.removeListener(this.hideArrangement);
    }
}
